export class Type1Dto{
    valueAdditionOneId:number;
    code:string;
    name:string;
    remarks:string;
    createdUser:string;
    isActive:boolean;
    
    /**
     * 
     * @param valueAdditionOneId 
     * @param code 
     * @param name 
     * @param remarks 
     * @param createdUser
     * @param isActive
     */
    constructor(valueAdditionOneId:number,code:string,name:string,remarks:string,createdUser:string,isActive:boolean){
    this.valueAdditionOneId = valueAdditionOneId;
    this.code = code;
    this.name = name;
    this.remarks = remarks;
    this.createdUser = createdUser;
    this.isActive = isActive
    }
}